// extracted by mini-css-extract-plugin
export default {"listContainer":"profile-navigation_listContainer__i239R","navList":"profile-navigation_navList__4er00","navListItem":"profile-navigation_navListItem__PIpq9"};